(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/taggedTemplateLiteralLoose', 'react-emotion', '../styles/typography/getVariantFromProps', '../styles/typography/getStyleFromProps'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/taggedTemplateLiteralLoose'), require('react-emotion'), require('../styles/typography/getVariantFromProps'), require('../styles/typography/getStyleFromProps'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.taggedTemplateLiteralLoose, global.reactEmotion, global.getVariantFromProps, global.getStyleFromProps);
    global.headers = mod.exports;
  }
})(this, function (exports, _taggedTemplateLiteralLoose2, _reactEmotion, _getVariantFromProps, _getStyleFromProps) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.H6 = exports.H5 = exports.H4 = exports.H3 = exports.H2 = exports.H1 = undefined;

  var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);

  var _reactEmotion2 = _interopRequireDefault(_reactEmotion);

  var _getVariantFromProps2 = _interopRequireDefault(_getVariantFromProps);

  var _getStyleFromProps2 = _interopRequireDefault(_getStyleFromProps);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _templateObject = (0, _taggedTemplateLiteralLoose3.default)(['\n  ', ';\n  ', ';\n'], ['\n  ', ';\n  ', ';\n']);

  var H1 = (0, _reactEmotion2.default)('h1')(_templateObject, _getStyleFromProps2.default, _getVariantFromProps2.default);
  var H2 = (0, _reactEmotion2.default)('h2')(_templateObject, _getStyleFromProps2.default, _getVariantFromProps2.default);
  var H3 = (0, _reactEmotion2.default)('h3')(_templateObject, _getStyleFromProps2.default, _getVariantFromProps2.default);
  var H4 = (0, _reactEmotion2.default)('h4')(_templateObject, _getStyleFromProps2.default, _getVariantFromProps2.default);
  var H5 = (0, _reactEmotion2.default)('h5')(_templateObject, _getStyleFromProps2.default, _getVariantFromProps2.default);
  var H6 = (0, _reactEmotion2.default)('h6')(_templateObject, _getStyleFromProps2.default, _getVariantFromProps2.default);

  exports.H1 = H1;
  exports.H2 = H2;
  exports.H3 = H3;
  exports.H4 = H4;
  exports.H5 = H5;
  exports.H6 = H6;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/elements/headers.js
// module id = 829
// module chunks = 1